import c from 'classnames';
import { NavLink } from 'react-router-dom';

import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { usePortalConfigs } from 'hooks/usePortalConfigs';
import usePartner from 'services/partner/usePartner';

import WhiteLogoSvg from 'assets/images/logos/logo-full-white.svg';
import LogoSvg from 'assets/images/logos/TH-logo.svg';

import styles from './Brand.module.css';

export const WhiteLogo = ({ fillHeight = false }) => (
  <div className={styles.logoWrap}>
    <img
      src={WhiteLogoSvg}
      className={c(styles.logoSvg, fillHeight && styles.fillHeight)}
    />
  </div>
);
export const Logo = ({
  fillHeight = false,
  className,
}: {
  fillHeight?: boolean;
  className?: string;
}) => (
  <div className={c(styles.logoWrap, className)}>
    <img
      src={LogoSvg}
      className={c(styles.logoSvg, fillHeight && styles.fillHeight)}
    />
  </div>
);

export const Brand = ({ href = '/', color = 'dark', fillHeight = false }) => {
  const { data: partner, isLoading, isFetching } = usePartner();
  const { currentTinyAccount } = useCurrentKitAndTinyAccount();
  const { config: portalConfig } = usePortalConfigs();
  // Only show partner logo if display_partner_logo config is true
  const shouldDisplayPartnerLogo = portalConfig.display_partner_logo;

  // Wait for partner query to complete before rendering to avoid logo flash
  const isLoadingPartner = isLoading || isFetching;

  return (
    <NavLink
      to='/'
      state={{ tinyAccount: currentTinyAccount }}
      className={styles.logoLink}
    >
      <h1 className={'invisible'}>Tiny Health</h1>
      {isLoadingPartner ? (
        // Show empty space while loading to avoid flash
        <div className={styles.logoWrap} style={{ minHeight: '40px' }} />
      ) : color !== 'dark' ? (
        shouldDisplayPartnerLogo && partner?.light_logo ? (
          <div className={styles.logoWrap}>
            <img
              className={styles.logoSvg}
              src={partner?.light_logo}
              alt='partner logo'
            />
          </div>
        ) : (
          <WhiteLogo fillHeight={fillHeight} />
        )
      ) : shouldDisplayPartnerLogo && partner?.logo ? (
        <div className={styles.logoWrap}>
          <img
            className={c(styles.logoSvg, fillHeight && styles.fillHeight)}
            src={partner?.logo}
            alt='partner logo'
          />
        </div>
      ) : (
        <Logo fillHeight={fillHeight} />
      )}
    </NavLink>
  );
};
